"use client"

import { Alert } from "@mantine/core"
import { TbAlertTriangle } from "react-icons/tb"

export interface StagingBannerProps {
  title: string
  message: string
}

export function StagingBanner({ title, message }: StagingBannerProps) {
  if (process.env.NEXT_PUBLIC_APP_ENV === "production") return null

  return (
    <Alert
      icon={<TbAlertTriangle size={18} />}
      title={title}
      color="yellow"
      radius={0}
      className="border-b border-yellow-400"
    >
      {message}
    </Alert>
  )
}
